import { authTypes } from 'redux/auth';

const closeIntercom = () => {
  // Web (uppercase Intercom)
  if (window.Intercom) {
    window.Intercom('shutdown');
  }

  // Cordova (lowercase intercom)
  if (window.intercom) {
    window.intercom.logout();
  }
};

export default () => next => action => {

  const { type } = action;

  switch (type) {
    case authTypes.logoutSuccess:
      closeIntercom();
      break;
    default:
      break;
  }

  next(action);
};
